export default __webpack_public_path__ + "static/media/pulmonology.bc1f0a5f.png";